import { useEffect } from 'react'
import { withTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import { SeoTags } from '../../components'
import { FlightsListComponent } from '../../components/info/AllFlightsComponent'
import { setShowSearch } from '../../store/appConfigsSlice'

const FlightsPage = () => {
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(setShowSearch(false))
  }, [dispatch])

  return (
    <>
      <SeoTags pageKey="flightsList" />
      <FlightsListComponent />
    </>
  )
}

export default withTranslation()(FlightsPage)